import React from 'react'
import GoogleChromeLogo from '../../_assets/chrome_logo.png'
import NotificationLinuxLogo from '../../_assets/notification_linux.png'
import styles from './style.module.scss'

export const NotificationIosExample = ({data}) => {
  return (<>
    {
      data.title ?
        <>
          <p className={styles['notification__title']}>Padrão</p>
          <div className={`${styles['notification']} ${styles['notification__ios']} ${styles['active']}`}>
            <div data-prop="header">
              <img src={GoogleChromeLogo} />
              <p style={{textTransform: "uppercase"}}>{"www."+JSON.parse(sessionStorage.getItem("selected_domain")).root}</p>
              <span>agora</span>
            </div>
            <div data-prop="content">
              <div data-prop="content__text">
                <h2>{data.title}</h2>
                { data.message ? <p>{data.message}</p> : null }
              </div>
            </div>
          </div>
        </>
      : <p className={styles['notification__title']}>Informe o título da notificação para visualizar o exemplo.</p>
    }
  </>)
}

export const NotificationOsxExample = ({data}) => {
  return (<>
    {
      data.title ?
        <>
          <p className={styles['notification__title']}>Fechada</p>
          <div className={`${styles['notification']} ${styles['notification__osx']}`}>
            <div data-prop="navigator">
              <img src={GoogleChromeLogo} style={{width: "60px", height: "60px"}}/>
            </div>
            <div data-prop="content__closed">
              <h2>{data.title}</h2>
              <span>{"www."+JSON.parse(sessionStorage.getItem("selected_domain")).root}</span>
              <p>{data.message ? data.message.length > 50 ? data.message.substr(0, 50) + '...' : data.message : "Sem mensagem"}</p>
            </div>
            {
              data.icon_uri ?
                <div data-prop="image">
                  <img src={data.icon_uri} />
                </div>
              : null
            }
            <div data-prop="buttons">
              <button type="button">Fechar</button>
              <button type="button">Opções</button>
            </div>
          </div>
          <p className={styles['notification__title']}>Aberta</p>
          <div className={`${styles['notification']} ${styles['notification__osx']} ${styles['active']}`}>
            <div data-prop="header">
              <img src={GoogleChromeLogo} />
              <p>GOOGLE CHROME</p>
              <span>agora</span>
            </div>
            <div data-prop="content">
              <div data-prop="content__text">
                <h2>{data.title}</h2>
                <span>{"www."+JSON.parse(sessionStorage.getItem("selected_domain")).root}</span>
                <p>{data.message ? data.message : "Sem mensagem"}</p>
              </div>
              {
                data.icon_uri ?
                  <div data-prop="content__image">
                    <img src={data.icon_uri} />
                  </div>
                : null
              }
            </div>
          </div>
        </>
      : <p className={styles['notification__title']}>Informe o título da notificação para visualizar o exemplo.</p>
    }
  </>)
}

export const NotificationWindowsExample = ({data, viewOnly}) => {
  return (<>
    {
      data.title ?
        <>
          {!viewOnly && <p className={styles['notification__title']}>Padrão</p>}
          <div className={`${styles['notification']} ${styles['notification__windows']}`}>
            {
              data.image ?  
                <div data-prop="image">
                  <img src={data.image} />
                </div>
              : null
            }
            <div data-prop="content">
              {
                data.icon_uri ? 
                  <div data-prop="content__image">
                    <img src={data.icon_uri} />
                  </div>
                : null
              }
              <div data-prop="content__text">
                <h2>{data.title}</h2>
                <p>{data.message ? data.message : "Sem mensagem"}</p>
                <span>Google Chrome • {"www."+JSON.parse(sessionStorage.getItem("selected_domain")).root}</span>
              </div>
            </div>
            {
              data.notification_buttons ?
                <div data-prop="buttons">
                  <button type="button">Fechar</button>
                  <button type="button">Confira!</button>
                </div>
              : null
            }
          </div>
        </>
      : <p className={styles['notification__title']}>Informe o título da notificação para visualizar o exemplo.</p>
    }
  </>)
}

export const NotificationLinuxExample = ({data}) => {
  return (<>
    {
      data.title ?
        <>
          <p className={styles['notification__title']}>Fechada</p>
          <div className={`${styles['notification']} ${styles['notification__linux']}`}>
            <div>
              <img src={data.icon_uri ? data.icon_uri : NotificationLinuxLogo} />
            </div>
            <div>
              <h2>{data.title}</h2>
              <p>{data.message ? data.message.length > 50 ? data.message.substr(0, 50) + '...' : data.message : "Sem mensagem"}</p>
            </div>
          </div>
          <p className={styles['notification__title']}>Aberta</p>
          <div className={`${styles['notification']} ${styles['notification__linux']} ${styles['active']}`}>
            <div>
              <img src={data.icon_uri ? data.icon_uri : NotificationLinuxLogo} />
            </div>
            <div>
              <h2>{data.title}</h2>
              <p>{data.message ? data.message : "Sem mensagem"}</p>
            </div>
          </div>
        </>
      : <p className={styles['notification__title']}>Informe o título da notificação para visualizar o exemplo.</p>
    }
  </>)
}

export const NotificationAndroidExample = ({data}) => {
  return (<>
    {
      data.title ?
        <>
          <p className={styles['notification__title']}>Fechada</p>
          <div className={`${styles['notification']} ${styles['notification__android']}`}>
            <div data-prop="content" style={{margin: 0}}>
              <div data-prop="content__text">
                <span>{`www.${JSON.parse(sessionStorage.getItem("selected_domain")).root}`}</span>
                <h2>{data.title}</h2>
                <p>{data.message ? data.message.length > 50 ? data.message.substr(0, 50) + '...' : data.message : "Sem mensagem"}</p>
              </div>
              {
                data.icon_uri ?
                  <div data-prop="content__image">
                    <img src={data.icon_uri} />
                  </div>
                : null
              }
            </div>
          </div>
          <p className={styles['notification__title']}>Aberta</p>
          <div className={`${styles['notification']} ${styles['notification__android']} ${styles['active']}`}>
            <div data-prop="content">
              <div data-prop="content__text">
                <span>{`www.${JSON.parse(sessionStorage.getItem("selected_domain")).root}`}</span>
                <h2>{data.title}</h2>
                <p>{data.message ? data.message : "Sem mensagem"}</p>
              </div>
              {
                data.icon_uri ?
                  <div data-prop="content__image">
                    <img src={data.icon_uri} />
                  </div>
                : null
              }
            </div>
            {
              data.image ?
                <div data-prop="image">
                  <img src={data.image} />
                </div>
              : null
            }
          </div>
        </>
      : <p className={styles['notification__title']}>Informe o título da notificação para visualizar o exemplo.</p>
    }
    
  </>)
}